import React from 'react';
import {ProductCompareUnion} from "../interfaces";

const tdStyle= {
    width: '20%',
    verticalAlign: 'top',
    height: 'inherit,'
};

const removeIconStyle = {
    right: '13px',
    top: '5px',
};

interface TR_ROW_TITLE {
    productCompareUnionList?: ProductCompareUnion[];
    propTitle: string
    propDescr?: string
    emptyServers: number
}

const TR_ROW_TITLE = (props: TR_ROW_TITLE) => {

    const productCompareUnionList  = props.productCompareUnionList;
    const propTitle  = props.propTitle;
    const propDescr  = props.propDescr;
    const emptyServers = props.emptyServers;
    const read_prop = (obj: any, prop:string) => {
        return obj[prop];
    }
    return (
        <tr key={`tr-${propTitle.toLowerCase()}`}>
            <td>
                <div className="pt-10 pb-2 text-lg font-bold">{propTitle}</div>
                {propDescr !== null && <div className="text-sm font-normal text-gray-450 pt-1">{propDescr}</div>}
            </td>
            { productCompareUnionList!= null && propTitle != null &&
                productCompareUnionList?.map((item, i) => {
                    return (
                        <td key={ `td-title-${propTitle.toLowerCase()}-${ i }` } className="border-t">

                        </td>
                    )
                })
            }

            {
                emptyServers > 0 &&
                <>{[...Array(emptyServers)].map((_el, index) => {
                    return <td key={ `empty-included-${ index }` }></td>
                })}</>
            }
        </tr>
    )
};

export default TR_ROW_TITLE;